import { render, staticRenderFns } from "./fcPicDetail.vue?vue&type=template&id=414ef0ca&"
import script from "./fcPicDetail.vue?vue&type=script&lang=js&"
export * from "./fcPicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports